import { render, staticRenderFns } from "./SuperIntendenciaProlipa.vue?vue&type=template&id=7ccce350&scoped=true"
import script from "./SuperIntendenciaProlipa.vue?vue&type=script&lang=js"
export * from "./SuperIntendenciaProlipa.vue?vue&type=script&lang=js"
import style0 from "./SuperIntendenciaProlipa.vue?vue&type=style&index=0&id=7ccce350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccce350",
  null
  
)

export default component.exports